import { css, SerializedStyles } from '@emotion/react'

export const ifNthOfType = (n: number, style: SerializedStyles) => css`
	&:nth-of-type(${n}) {
		${style};
	}
`
